import React from "react";

import './style.css'

export const Header = () => {
  return (
    <nav>
      <p>Fruites i verdures de temporada</p>
    </nav>
  );
};
